import {
  EuiBadge,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLoadingSpinner,
} from "@inscopix/ideas-eui";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";

const css = { width: 150 };

export const ToolEditorSaveStatus = () => {
  const status = useToolEditorContext((s) => s.draftSpecSaveStatus);

  switch (status) {
    case "ERROR":
      return (
        <EuiBadge css={css} color="danger" iconType="warning" iconSide="left">
          Error syncing changes
        </EuiBadge>
      );

    case "SAVED":
      return (
        <EuiBadge css={css} color="hollow" iconType="check" iconSide="left">
          Changes synced
        </EuiBadge>
      );

    case "UNSAVED":
      return (
        <EuiBadge css={css} color="hollow" iconSide="left">
          Unsaved Changes
        </EuiBadge>
      );
    case "SAVING":
      return (
        <EuiBadge css={css} color="hollow">
          <EuiFlexGroup gutterSize="xs" alignItems="center">
            <EuiFlexItem grow={false}>
              <EuiLoadingSpinner size="s" />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>Syncing changes</EuiFlexItem>
          </EuiFlexGroup>
        </EuiBadge>
      );
  }
};
